import * as React from 'react';
import Select from 'react-select';

import { ProfileFormContext } from '../../ProfileEditForm';
import { ACTIONS } from '../ProfileFormReducer';

export default function Skills() {
  const [state, dispatch] = React.useContext(ProfileFormContext);
  const { skills, skill_categories, profile } = state;

  const handleSelectChange = (selected, category_skills) => {
    // Get selected skills
    const selected_skills = category_skills.filter(
      skill => selected.map(s => s.value).includes(skill.id)
    );

    // Get unselected skills
    const unselected_skills = category_skills.filter(
      skill => !selected.map(s => s.value).includes(skill.id)
    );

    // Update skills directly through reducer
    const newSkillState = [...profile.skill_ids]
      .concat(selected_skills.map(s => s.id).filter(s => !profile.skill_ids.includes(s)))
      .filter(s => !unselected_skills.map(u => u.id).includes(s));

    dispatch({ type: ACTIONS.SET_SKILLS, payload: newSkillState });
  };

  return (
    <div>
      <label htmlFor="skills" className="form-label">Skills</label>
      <div>
        {skill_categories.map(category => {
          const category_skills = skills.filter(skill => skill.category === category)

          // Skip if category.name == "Language Proficiency (other than English)" & skill with id of 55 is not in job_skills
          const category_lang = category === "Language Proficiency (other than English)"
            && !profile.skill_ids.includes(55)

          if (category_lang) {
            return null
          }

          const select_skills = category_skills.sort((a, b) => a.name.localeCompare(b.name))
            .map(skill => ({
              value: skill.id,
              label: skill.name,
              color: skill.color
            }))

          const customStyles = {
            control: (styles: any, { isFocused }: any) => ({
              ...styles,
              minHeight: '48px',
              backgroundColor: '#ffffff',
              borderColor: isFocused ? '#085ec8' : '#e2e8f0',
              borderWidth: '2px',
              borderRadius: '12px',
              boxShadow: isFocused ? '0 0 0 3px rgba(8, 94, 200, 0.15)' : 'none',
              '&:hover': {
                borderColor: '#cbd5e0'
              }
            }),
            option: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => ({
              ...styles,
              backgroundColor: isSelected
                ? data?.color || '#085ec8'
                : isFocused
                ? 'rgba(8, 94, 200, 0.1)'
                : 'white',
              color: isSelected ? 'white' : '#2d3748',
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }),
            multiValue: (styles: any) => ({
              ...styles,
              backgroundColor: 'transparent',
              borderRadius: '50px',
              padding: '2px'
            }),
            multiValueLabel: (styles: any, { data }: any) => ({
              ...styles,
              backgroundColor: data.color || '#085ec8',
              color: 'white',
              borderRadius: '50px 0 0 50px',
              paddingLeft: 12,
              paddingRight: 6,
              paddingTop: 6,
              paddingBottom: 6,
              fontSize: '0.9rem',
              fontWeight: 500
            }),
            multiValueRemove: (styles: any, { data }: any) => ({
              ...styles,
              backgroundColor: data.color || '#085ec8',
              color: 'white',
              borderRadius: '0 50px 50px 0',
              paddingRight: 8,
              paddingLeft: 4,
              marginLeft: 0,
              '&:hover': {
                backgroundColor: data.color ? data.color : '#034ba6',
                color: 'white'
              }
            }),
            placeholder: (styles: any) => ({
              ...styles,
              color: '#9ca3af',
              fontSize: '1rem'
            }),
            input: (styles: any) => ({
              ...styles,
              color: '#2d3748',
              fontSize: '1rem'
            })
          }

          const value = select_skills.filter(
            skill => profile.skill_ids.includes(skill.value)
          )

          const onChangeFunc = (selected) => {
            handleSelectChange(selected, category_skills)
          }

          return (
            <div className="mb-4" key={category}>
              <h6 className="fw-bold">{category}</h6>
              <Select
                styles={customStyles}
                options={select_skills}
                isMulti
                placeholder={`Select ${category.toLowerCase()} skills...`}
                value={value}
                onChange={onChangeFunc}
                className="react-select-container"
                classNamePrefix="react-select"
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
